import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FEE2E2',
    borderRadius: 8,
    padding: 12,
    marginHorizontal: 16,
    marginTop: 16,
    borderWidth: 1,
    borderColor: '#EC221F',
  },
  iconWrapper: {
    marginRight: 8,
  },
  icon: {
    color: '#B91C1C',
    fontSize: 20,
  },
  textWrapper: {
    flex: 1,
  },
  text: {
    color: '#900B09',
    fontSize: 12,
    fontWeight: '500',
    flexShrink: 1,
  },
});
